<template></template>

<script>

  import ActivityNavigator from "@/utils/ActivityNavigator"

  export default {
    name: "ActivityRedirectItem",
    props: {
      LoanTasks: {
        type: Array,
        default: () => []
      },

      IsLoanTask: {
        type: Boolean,
        default: false
      },

      CurrentLoanTask: {
        type: String,
        default: ''
      },

      RedirectActivity: {
        type: String,
        required: true
      }
    },

    created: function () {
      if (this.IsLoanTask) {
        if (!this.LoanTasks.includes(this.CurrentLoanTask)) {
          ActivityNavigator.navigateTo(this.RedirectActivity);
        }
      } else {
        //need to handle it.
      }
    }
  }
</script>

<style scoped></style>